import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Partner } from '../../models/partner';
import { DropDownItem } from '../../../general/components/dropdown/dropdown.item';
import { NgForm } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { LocalizationService } from '../../../../services/localization.service';
import { PartnerFieldsConfigurations } from '../../models/partner-fields-configuration';
import { FieldInformation } from 'src/app/modules/general/models/field-information';
import { FieldInformationType } from 'src/app/modules/general/models/field-information-type.enum';


@Component({
  selector: 'app-partner-form',
  templateUrl: './partner-form.component.html',
  styleUrls: ['./partner-form.component.css']
})
export class PartnerFormComponent implements OnInit {

  @Input()
  repeatEmail: string;

  @Input()
  partner: Partner;

  @Input()
  minAge: number;

  @Input()
  isChild: boolean;

  @Input()
  showRepeatEmail: boolean;

  @Input()
  showGender: boolean;

  @Input()
  showPartnerTitle: boolean;

  @Input()
  showZip: boolean;

  @Input()
  showPartnerNames: boolean;

  @Input()
  showPhone = false;

  @Input()
  showAddress = false;

  @ViewChild(NgForm, { static: true }) form;

  @Output() eventFormValid = new EventEmitter();
  @Output() eventFormInvalid = new EventEmitter();

  @Output() eventFormDirty = new EventEmitter();
  @Output() eventFormNotDirty = new EventEmitter();

  maxDate: Date;

  @Input()
  easyMode: boolean;

  @Input()
  fieldsConfigurations: PartnerFieldsConfigurations;

  constructor(
    private shopSettingsService: ShopSettingsService,
    private localizationService: LocalizationService,
  ) { }

  ngOnInit(): void {
    if (this.partner === undefined) {
      this.partner = new Partner();
    } else {
      this.repeatEmail = this.partner.email;
    }

    if (this.fieldsConfigurations && this.fieldsConfigurations.additionalFields) {
      for (const field of this.fieldsConfigurations.additionalFields) {
        const name = field.name;
        if (!this.partner.additionalFields[name]) {
          this.partner.additionalFields[name] = '';
        }
      }
    }

    this.maxDate = new Date();

    this.form.valueChanges.subscribe(
      data => {
        if (this.form.valid) {
          this.eventFormValid.emit(this.form);
        } else {
          this.eventFormInvalid.emit(this.form);
        }
        if (this.form.dirty) {
          this.eventFormDirty.emit(this.form);
        } else {
          this.eventFormNotDirty.emit(this.form);
        }
      });
  }

  get genders(): DropDownItem[] {
    return this.shopSettingsService.genderList.map(x => new DropDownItem(x.code, x.name));
  }

  get partnerTitles(): DropDownItem[] {
    return this.shopSettingsService.partnerTitleList.map(x => new DropDownItem(x.code, x.name));
  }

  get isFormValid(): Observable<boolean> {
    return Observable.create((observable: Subscriber<boolean>) => {
      this.form.valueChanges.subscribe(
        data => {
          observable.next(this.form.valid);
        });
    });
  }

  get showEmail(): boolean {
    return !this.isChild;
  }

  get showDateOfBirth(): boolean {
    return !this.isChild;
  }

  get changeNamePosition(): boolean {
    if (this.localizationService.currentLang === 'hu-HU') {
      return true;
    }
    return false;
  }

  onChangePartnerTitle(selected): void {
    this.partner.title = +selected;
  }

  get isShowPartnerFirstLastNames(): boolean {
    return (!this.changeNamePosition && !this.easyMode) || (this.showPartnerNames && !this.changeNamePosition);
  }

  get isShowPartnerLastFirstNames(): boolean {
    return (this.changeNamePosition && !this.easyMode) || (this.showPartnerNames && this.changeNamePosition);
  }

  isFieldAvailable(name: string): boolean {
    if (!this.fieldsConfigurations) {
      return true;
    }

    return this.fieldsConfigurations.isFieldAvailable(name);
  }

  get additionalFields(): Array<FieldInformation> {
    if (!this.fieldsConfigurations || !this.fieldsConfigurations.additionalFields) {
      return [];
    }
    return this.fieldsConfigurations.additionalFields;
  }

  isBooleanField(field: FieldInformation): boolean {
    return field?.type === FieldInformationType.boolean;
  }

  isCharsField(field: FieldInformation): boolean {
    return field?.type === FieldInformationType.char;
  }

  isDateField(field: FieldInformation): boolean {
    return field?.type === FieldInformationType.date;
  }
}
